import { Link, useTrackCampaignOnLoad } from '@packages/shared';
import { useEffect } from 'react';
import { PromotionBannerTestIds } from '../PromotionBannerTestIds';
import type { LinkPromotion } from '../types';

export const PromotionAsLink = ({ data }: { data: LinkPromotion }): JSX.Element => {
  const { trackClick, trackDisplay } = useTrackCampaignOnLoad(data);

  useEffect(() => {
    trackDisplay();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Link
      href={data.linkReady}
      data-testid={PromotionBannerTestIds.asLink}
      noLinkStyle
      onClick={() => trackClick()}
    >
      {data.title}
    </Link>
  );
};
